module.exports = __webpack_public_path__ + "static/media/dsr_cer2.4e1a2227.svg";